// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"73879b3d","213":"69e9e5f3","366":"2c4271c4","413":"fa472a77","531":"fd02b37d"}[chunkId] + ".chunk.js";
};